import React, { useEffect, useState } from 'react'
import { View, StyleSheet, ScrollView, TouchableOpacity, Platform, Linking } from 'react-native'

import {
  Text,
  Label,
  Description,
  Space,
  ProductListItem,
  GroupedProductItem
} from '@sart/components'
import client, { basketHelper, catalogHelper, useClient } from '@sart/client'
import { useContent } from '@sart/content'
import { adaptive, colors, typography } from '@sart/styles'
import { ChevronRight, ShoppingBag } from '@sart/icons'
import { testID } from '@sart/utilities'
import { fontSize } from '@sart/styles/src/adaptive'


export default function Addons(props) {
  const { navigation } = props

  const content = useContent()

  const [loading, setLoading] = useState(false)

  const {
    cache: {
      addons,
      basket,
      accounts,
      language
    } = {}
  } = useClient()
  const showAddons = addons && addons.length > 0
  const showLabels = showAddons

  const activated = client.cache.activated

  async function getAddOns() {
    if (addons === undefined) {
      for (var i; i < accounts.length; i++) {
        client.getAvailableAddons(accounts[i])
      }
    }
  }

  function checkoutAddOn(product) {
    navigation.navigate('PurchaseAddonReview', { product })
  }

  var disabledProduct = [] //empty currently. but if we want to change how rules display to show disabled items we will need this

  return (
    <ScrollView style={styles.container} contentContainterStyle={styles.contentContainer}>
      <View style={styles.addOns}>
        {!activated &&
          <Description style={[styles.description, { fontSize: 16 }]}>
            Please activate your subscription in order to be able to view and/or purchase addons
          </Description>
        }

        {showAddons && activated && <>
          {showLabels && <>
            <Label style={[styles.text]}>{content.addons.title}</Label>
            <Space height={12} />
          </>}

          {addons.map(addOn => (
            <React.Fragment key={addOn.productId}>
              <ProductListItem
                disabled={disabledProduct.includes(addOn.productId)}
                product={addOn}
                onPress={() => checkoutAddOn(addOn)}
                priceStyle={styles.price}
                language={language}
                injectedContent={content}
                {...testID(addOn.productName)}
                imageColor={colors.white}
              />
              <Space height={12} />
            </React.Fragment>
          ))}
        </>}
      </View>
    </ScrollView>
  )
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: colors.darkCharcoal,
    paddingTop: 24,
    paddingBottom: 10,
    ...adaptive.wrapperPadding,
    width: '100%',
  },
  contentContainer: {
    ...Platform.select({
      web: {
        alignItems: 'center'
      }
    }),
  },
  addOns: {
    flex: 1,
    maxWidth: 600,
    minWidth: Platform.OS === 'web' ? 600 : '100%',
    alignSelf: Platform.OS === 'web' ? 'center' : 'flex-start',
    paddingBottom: 40
  },
  checkout: {
    position: 'relative',
    top: Platform.OS === 'web' ? '0.5%' : '7%',
    flexDirection: 'row',
    justifyContent: 'center',
    alignSelf: 'flex-end',
    zIndex: 1
  },
  checkoutText: {
    fontSize: 18,
    color: colors.white
  },
  description: {
    textAlign: 'center',
    color: colors.white,
    ...typography.demi,
    marginLeft: 15,
    marginRight: 15,
    fontSize: 12,
  },
  price: {
    color: colors.white
  },
  circle: {
    // position: 'absolute',
    justifyContent: 'center',
    alignItems: 'center',
    bottom: '4%',
    right: '40%',
    // left: 16,
    backgroundColor: colors.srDarkGreen,
    borderRadius: 8
  },
  text: {
    fontSize: 16,
    fontWeight: '700',
    paddingLeft: 5,
    paddingRight: 5,
    paddingTop: 3,
    paddingBottom: 2,
    color: colors.white,
    textAlign: 'center',
  },
  priceStyle: {
    color: colors.srTextInput
  },
  productStyle: {
    backgroundColor: colors.srGreen
  },
  numberText: {
    textAlign: 'center',
    ...typography.extrabold,
    color: colors.srDarkGreen,
    fontSize: 20
  }
})

